// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: Object,
    options: {
        scripts: array,
    },
};

const scripts = [
    {
        src: 'http://play2.qbrick.com/framework/GoBrain.min.js',
        type: 'script',
    },
];

export default class Qbrick extends Component<Props> {
    constructor(props) {
        super(props);
        this.state = {
            account_id: '',
            media_id: '',
            configuration_id: '',
            isLoaded: false,
        };
    }

    componentDidMount() {
        const { account_id, media_id } = this.props.content;
        const configuration_id =
            this.props.content.configuration_id || 'default';
        this.setState({
            account_id,
            media_id,
            configuration_id,
        });
    }

    createVideoPlayer = () => {
        const embedSettings = {
            config:
                '//video.qbrick.com/play2/api/v1/accounts/' +
                this.state.account_id +
                '/configurations/' +
                this.state.configuration_id,
            data:
                '//video.qbrick.com/api/v1/public/accounts/' +
                this.state.account_id +
                '/medias/' +
                this.state.media_id,
            widgetId: 'player',
            repeat: false,
            autoplay: false,
        };

        const reInitialize = function() {
            GoBrain.initialize(embedSettings).on('queueComplete', reInitialize);
        };

        const player = window.GoBrain.create(
            document.getElementById('divPlayerContainer'),
            embedSettings
        ).on('queueComplete', reInitialize);
    };

    componentDidUpdate(nextProps) {
        const customScripts = this.props.options && this.props.options.scripts;

        if (!this.state.isLoaded) {
            if (customScripts)
                loadScripts(customScripts)
                    .then(() => {
                        this.createVideoPlayer();
                    })
                    .catch(error => {
                        console.log('Could not load qubrick scripts: ', error);
                    });
            else
                loadScripts(scripts)
                    .then(() => {
                        this.createVideoPlayer();
                    })
                    .catch(error => {
                        console.log('Could not load qubrick scripts: ', error);
                    });

            this.setState({ isLoaded: true });
        }
    }

    render() {
        return (
            <div id="divPageContainer">
                <div id="divPlayerContainer" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Qbrick.js